import React, { useEffect, useState } from "react";
import api from "../utils/api";


export default function ResetPassword() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") || "";
    const [valid, setValid] = useState(null);
    const [pw1, setPw1] = useState("");
    const [pw2, setPw2] = useState("");
    const [msg, setMsg] = useState("");

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                await api.get(`/api/auth/reset/verify`, { params: { token } });
                if (mounted) setValid(true);
            } catch {
                if (mounted) setValid(false);
            }
        })();
        return () => { mounted = false; };
    }, [token]);

    const submit = async (e) => {
        e.preventDefault();
        if (pw1 !== pw2) return setMsg("Passwords do not match.");
        try {
            await api.post(`/api/auth/reset`, { token, password: pw1 });
            setMsg("Password updated. You can now log in with your new password.");
        } catch (e) {
            setMsg("Reset failed. The link may have expired.");
        }
    };

    if (!token) return <div className="p-4 text-red-400">Missing token.</div>;
    if (valid === null) return <div className="p-4 text-gray-400">Checking link�</div>;
    if (!valid) return <div className="p-4 text-red-400">This link is invalid or expired.</div>;

    return (
        <div className="p-4 sm:p-6 max-w-md">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-blue-400">Choose a new password</h2>
            <form onSubmit={submit} className="space-y-3">
                <input
                    type="password" required minLength={8}
                    placeholder="New password (min 8 chars)"
                    className="w-full p-3 rounded bg-gray-700"
                    value={pw1} onChange={(e) => setPw1(e.target.value)}
                />
                <input
                    type="password" required minLength={8}
                    placeholder="Confirm new password"
                    className="w-full p-3 rounded bg-gray-700"
                    value={pw2} onChange={(e) => setPw2(e.target.value)}
                />
                {msg && <div className="text-sm text-yellow-300">{msg}</div>}
                <button className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-500 font-semibold">Update password</button>
            </form>
        </div>
    );
}

